<template>
  <div>
    <!-- mensajes de confirmacion ---->
    <mensajeSistema></mensajeSistema>
    <!-- FORMULARIO DEL COLEGIO (CREAR Y EDITAR) -->
    <v-form ref="formDatos" lazy-validation aria-autocomplete="off">
      <ComunDialogComp v-model="estadoComp" max-width="1080" @close-modal="cerrarModal" :title="parametros.title">
        <template v-slot:body>
          <!-- Datos del Colegio  -->
          <v-alert dense border="left" class="text-center" color="primary" dark>
            <h3>Información del colegio</h3>
          </v-alert>


          <v-row>
            <br>

            <v-col cols="10">

              <v-row class="pt-5">

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field label="Nombre" v-model="editedItem.nombre_colegio" type="text"
                    :rules="[rul.required, rul.max100]" prepend-icon="fa-school" required>
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field label="RUC" v-model="editedItem.ruc_colegio" type="text" prepend-icon="fa-id-badge"
                    :rules="[rul.required, rul.max11]" :counter="11" :max="11" :maxlength="11">
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition"
                    offset-y max-width="290px" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-flex>
                        <v-text-field label="Fecha de constitución" v-model="editedItem.fec_constitucion"
                          prepend-icon="fa-calendar-alt" readonly v-bind="attrs" v-on="on" :rules="[rul.required]">

                        </v-text-field>
                      </v-flex>
                    </template>
                    <v-date-picker v-model="editedItem.fec_constitucion" no-title scrollable @input="menu2 = false"
                      :max="nowDate"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field label="Correo electrónico" v-model="editedItem.correo_colegio" type="email"
                    prepend-icon="fa-envelope" :rules="[rul.required, rul.email, rul.max50]" aria-autocomplete="off">
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field label="Sitio web" v-model="editedItem.web_colegio" prepend-icon="fa-globe"
                    placeholder="https://colegio.inteligenio" mask="https://*.com">
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field label="Extensión" v-model="editedItem.extension" prepend-icon="mdi-domain"
                    placeholder=".com.edu.pe" v-mask="'.aaa.aaaaa'">
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field label="Teléfono" v-model="editedItem.telf_colegio" type="tel"
                    prepend-icon="fa-phone-alt" :rules="[rul.required, rul.max20]" placeholder="+01 000 00"
                    v-mask="'+##############'">
                    <!-- @keydown="validarTelefono" -->
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-select label="País" v-model="editedItem.id_pais" :items="parametros.paises" item-value="id"
                    item-text="nombre_pais"
                    @change="$emit('changeDpto', editedItem.id_pais); getUbicacion1(editedItem.id_pais)"
                    prepend-icon="fa-flag" :rules="[rul.required]">
                  </v-select>
                </v-col>
                <!-- DEPARTAMENTO_DOM 1 -->
                <v-col cols="12" sm="4" md="4" class="py-0">
                  <!-- :items="ubicacion1" -->
                  <v-autocomplete label="Departamento" v-model="editedItem.id_ubicacion1"
                    :items="parametros.departamentos" item-value="id" item-text="nombre_ubicacion1"
                    @change="$emit('changeProv', editedItem.id_ubicacion1)" prepend-icon="fa-flag"
                    :rules="[rul.required]">
                  </v-autocomplete>
                </v-col>
                <!-- PROVINCIA -->
                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-autocomplete label="Provincia" v-model="editedItem.id_ubicacion2" :items="parametros.provincias"
                    item-value="id" item-text="nombre_ubicacion2"
                    @change="$emit('changeDist', editedItem.id_ubicacion2); getUgelDreProvince(editedItem.id_ubicacion2)"
                    prepend-icon="fa-flag" :rules="[rul.required]" autocomplete="off">
                  </v-autocomplete>
                </v-col>
                <!-- DISTRITO -->
                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-autocomplete label="Distrito" v-model="editedItem.id_ubicacion3" :items="parametros.distritos"
                    item-value="id" item-text="nombre_ubicacion3" prepend-icon="fa-flag"
                    @change="district(editedItem.id_ubicacion3)" :rules="[rul.required]">
                  </v-autocomplete>
                </v-col>
                <!-- DIRECCIÓN -->
                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-textarea label="Dirección" v-model="editedItem.direc_colegio" prepend-icon="fa-route" rows="2"
                    :rules="[rul.required, rul.max150]">
                  </v-textarea>
                </v-col>
                <!-- DRE -->
                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field label="Dirección Regional de Educación" type="text" v-model="editedItem.dre"
                    prepend-icon="fa-flag" :rules="[rul.required]">
                    <!-- :readonly="editedItem.dre.description != ''" -->
                  </v-text-field>
                </v-col>
                <!-- UGEL -->
                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field label="Unidad de Gestion Educativa Local" type="text" v-model="editedItem.ugel"
                    prepend-icon="fa-flag" :rules="[rul.required]">
                    <!-- :readonly="editedItem.ugel.description != ''" -->
                  </v-text-field>
                </v-col>
                <!-- RESOLUCIÓN --->
                <v-col cols="12" sm="4" md="4" lg="4" class="py-0">
                  <v-text-field label="Resolución" type="text" v-model="editedItem.resolucion_colegio"
                    prepend-icon="fa-user" :rules="[rul.max30]">
                  </v-text-field>
                </v-col>
                <!-- ESLOGAN --->
                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field label="Eslogan" type="text" v-model="editedItem.slogan_colegio" prepend-icon="fa-font"
                    :rules="[rul.max100]">
                  </v-text-field>
                </v-col>

                <!--- SUCURSALES --->
                <v-col cols="6" sm="4" md="4" class="py-0">
                  <v-radio-group v-model="editedItem.es_sucursal" label="¿Es una sede?">
                    <v-radio label="SÍ" :value="1"></v-radio>
                    <v-radio label="NO" :value="0"></v-radio>
                  </v-radio-group>
                </v-col>

                <!-- CAMBIO DE NOTAS -->
                <v-col cols="6" sm="4" md="4" class="py-0">
                  <v-radio-group v-model="editedItem.cambio_notas" label="Autorizar que el docente edite la nota:">
                    <v-radio label="SÍ" :value="true"></v-radio>
                    <v-radio label="NO" :value="false"></v-radio>
                  </v-radio-group>
                </v-col>

              </v-row>

            </v-col>

            <v-col cols="2">
              <!-- ?nocache=${new Date().getTime()} -->
              <v-col cols="12" md="12" sm="12" class="d-flex justify-center order-md-0 order-first" @click="pickLogo">
                <v-avatar width="140" height="170" class="avatar_fondo_add_img pa-1">
                  <v-icon color="grey lighten-2" class="fondo_add_img" size="60"
                    v-if="!editedItem.logo_colegio && !previewImgLogo">far fa-image</v-icon>
                  <v-img v-if="editedItem.logo_colegio && !previewImgLogo"
                    :src="`${rutaSpace}${editedItem.logo_colegio}`" aspect-ratio="1" dark contain class="fondo_add_img">

                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>


                  <v-img v-if="previewImgLogo" :src="previewImgLogo" contain aspect-ratio="1" class="fondo_add_img" />

                  <input type="file" style="display: none" ref="imageCol" accept=".jpg, .png, .gif"
                    @change="onFileLogo" />
                </v-avatar>
              </v-col>

            </v-col>

            <!-- CONFIGURAR  -->


            <!-- IDIOMA --->
            <v-col cols="12" sm="7" md="4" lg="4" class="py-0" v-if="visualizarIdioma">
              <v-select label="Idioma del colegio" v-model="editedItem.id_idioma" :items="idioma" item-value="id"
                item-text="desc_i18n" prepend-icon="fas fa-language" :rules="[rul.required]">
              </v-select>
            </v-col>

            <!-- SELECCIONAR COLEGIO PADRE (SUCURSALES) -->
            <v-col cols="12" sm="6" md="3" class="py-0" v-if="editedItem.es_sucursal == 1">
              <v-select label="Colegio" v-model="editedItem.parent_id_colegio" :items="Colegios_padres" item-value="id"
                item-text="nombre_colegio" prepend-icon="fa-school">
              </v-select>
            </v-col>



          </v-row>

          <!-- Datos responsable -->
          <v-row>
            <v-col cols="12" sm="12" md="12" class="pb-0">
              <v-alert dense border="left" class="text-center" color="primary" dark>
                <h3>Responsable del colegio</h3>
              </v-alert>
            </v-col>

            <v-col cols="12" sm="6" md="4" class="py-0">
              <v-text-field label="Nombre completo" v-model="editedItem.responsable_nombre" prepend-icon="fa-user"
                :rules="[rul.max60]"></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" class="py-0">
              <v-text-field label="Teléfono" type="number" v-model="editedItem.responsable_telf"
                prepend-icon="fa-phone-alt" :rules="[rul.max20]"></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" class="py-0">
              <v-text-field label="Correo electrónico" v-model="editedItem.responsable_correo"
                prepend-icon="fa-envelope" type="email" :rules="[rul.required, rul.email]">
              </v-text-field>
            </v-col>
          </v-row>

          <!-- Fin Datos del responsable -->

          <!-- Datos de Usuarios  WEBMASTER-->


          <v-row>
            <v-col cols="12">
              <v-alert dense border="left" class="text-center" color="primary" dark>
                <h3>Datos personales del usuario webmaster de inteligenio</h3>
              </v-alert>
            </v-col>
            <v-col cols="12" sm="12" md="9" class="pt-4">
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                  <v-text-field label="Nombres" type="text" v-model="datos.nombre_persona"
                    :rules="[rul.required, rul.max50]" :readonly="bloquearInput" aria-autocomplete="off"></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                  <v-text-field label="Apellido paterno" type="text" v-model="datos.ape1_persona"
                    :rules="[rul.required, rul.max40]" :readonly="bloquearInput" aria-autocomplete="off"></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                  <v-text-field label="Apellido materno" type="text" v-model="datos.ape2_persona" :rules="[rul.max40]"
                    :readonly="bloquearInput" aria-autocomplete="off"></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                  <v-select label="Tipo documento" v-model="datos.id_tipo_documento" :items="parametros.allTiposDoc"
                    item-value="id" item-text="desc_tipo_documento" :rules="[rul.required]" :readonly="bloquearInput"
                    @change="changedinamicValidation(datos.id_tipo_documento)">
                    <!-- @change="actualizar_tipo_documento" -->
                  </v-select>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                  <v-text-field label="Número de documento" v-model="datos.numdoc_persona" :readonly="bloquearInput"
                    :rules="dinamicValidation" :maxlength="length" :counter="length" aria-autocomplete="off">
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                  <v-select label="Sexo" v-model="datos.sexo_persona" :items="sexos" item-value="abbr"
                    item-text="nombre" :rules="[rul.required]" :readonly="bloquearInput">
                  </v-select>
                </v-col>
              </v-row>
            </v-col>

            <!--  Avatar de Persona actualizado 2020/07/04 -->
            <v-col cols="12" sm="12" md="3" class="d-flex justify-center order-first order-md-0" @click="pickAvatar">
              <v-avatar width="130" height="150" class="avatar_fondo_add_img">
                <v-icon color="grey lighten-2" class="fondo_add_img" size="60"
                  v-if="!datos.ruta_avatar_persona && !previewImgAvatar">fas fa-user-circle</v-icon>
                <!-- ?nocache=${new Date().getTime()} -->
                <v-img v-if="datos.ruta_avatar_persona && !previewImgAvatar"
                  :src="`${rutaSpace}/${datos.ruta_avatar_persona}`" dark contain class="fondo_add_img">
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>

                <v-img v-if="previewImgAvatar" :src="previewImgAvatar" contain aspect-ratio="1" dark
                  class="fondo_add_img" />

                <input type="file" style="display: none" ref="imageAvatar" accept=".jpg, .png, .gif"
                  @change="onFileAvatar" />
              </v-avatar>
            </v-col>

            <!-- fin pestaña usuarios ubicacion -->
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-menu v-model="menu3" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="datos.fecnac_persona" label="Fecha de nacimiento" v-on="on"
                    :rules="[rul.required]" readonly>
                  </v-text-field>
                </template>

                <v-date-picker v-model="datos.fecnac_persona" no-title @input="menu3 = false" :disabled="bloquearInput">
                  <!-- :max="maxDate" -->
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-autocomplete v-model="datos.id_pais_nacimiento" :items="parametros.allPaises" item-text="nombre_pais"
                item-value="id" :rules="[rul.required]" label="País de nacimiento" :readonly="bloquearInput"
                @change="select_pais">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-autocomplete label="Nacionalidad" v-model="datos.id_nacionalidad" :items="nacionalidades"
                item-text="desc_nacionalidad" item-value="id" :rules="[rul.required]" :readonly="bloquearInput">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4" md="4" lg="3" class="pt-0">
              <v-radio-group class="py-0" hide-details v-model="datos.estado_usuario" label="Estado ">
                <v-radio :label="`Activo`" :value="1" color="teal"></v-radio>
                <v-radio :label="`Inactivo`" :value="0" color="error"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col ols="12" sm="12" md="12" class="pb-0">
              <v-alert dense border="left" class="text-center" color="primary" dark>
                <h3>Datos de acceso del usuario webmaster de inteligenio</h3>
              </v-alert>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-text-field label="Nombre de usuario" v-model="datos.usu_usuario" type="text" :readonly="bloquearInput"
                :rules="[rul.required, rul.max40]">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-text-field label="Contraseña" v-model="datos.password_usuario" :type="show ? 'text' : 'password'"
                :append-icon="show ? 'fa-eye' : 'fa-eye-slash'" :rules="[rul.required]" class="input-group--focused"
                @click:append="show = !show">
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="12" class="pb-0">
              <v-alert dense border="left" class="text-center" color="primary" dark>
                <h3>Datos de ubicación y contacto del webmaster de inteligenio</h3>
              </v-alert>
            </v-col>
            <!-- DEPARTAMENTO_DOM 2 -->
            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-autocomplete label="Departamento" v-model="datos.id_ubicacion1" :items="Ubicacion1" item-value="id"
                item-text="nombre_ubicacion1" @change="loadUbicacion2(datos.id_ubicacion1)" :rules="[rul.required]">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-autocomplete label="Provincia" v-model="datos.id_ubicacion2" :items="Ubicacion2" item-value="id"
                item-text="nombre_ubicacion2" @change="loadUbicacion3(datos.id_ubicacion2)" :rules="[rul.required]">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-autocomplete label="Distrito" v-model="datos.id_ubicacion3" :items="Ubicacion3" item-value="id"
                item-text="nombre_ubicacion3" :rules="[rul.required]">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-text-field label="Teléfono" v-model="datos.telf_persona" type="number" :min="0" :rules="[rul.max12]">
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-text-field label="Correo electrónico" v-model="datos.correo_persona" type="email"
                :rules="[rul.required, rul.email]" aria-autocomplete="off">
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
              <v-text-field label="Dirección" v-model="datos.direc_persona" :rules="[rul.max150]"
                aria-autocomplete="off">
              </v-text-field>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
        <!-- <v-btn color="primary" @click="datatest"> datatest </v-btn> -->
          <v-spacer></v-spacer>
          <ButtonComp :loading="loading" :disabled="bloquearBotonGurdar" @click="saveItem()" text-button="Guardar"
            icon-but="fas fa-save" normal-button />
          <ButtonComp @click="$emit('close')" text-button="Cancelar" normal-button class-button="mx-2"
            classColor="red" />
        </template>
      </ComunDialogComp>

    </v-form>
  </div>
</template>

<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "../../../../helpers/axios";
import ComunDialogComp from "../../../../components/ComponentsEst/ComunDialogComp.vue";
import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";

import { mapMutations, mapActions } from "vuex";
import moment from "moment";
import { validationRules } from '../../../../helpers/validatorHelpers';

export default {
  name: "modalColegioFormulario",
  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },
  components: {
    ComunDialogComp,
    ButtonComp
  },
  data() {
    return {
      loading: false,
      datoLogin: sessionStorage,
      test: false,
      editedItem: [],
      pais: [],
      idioma: [],
      ubicacion1: [],
      ubicacion2: [],
      ubicacion3: [],
      menu2: false,
      bloquearInput: false,
      bloquearIdioma: false,
      visualizarIdioma: false,
      bloquearBotonGurdar: false,
      respuestaValidDoc: [],
      nowDate: moment(new Date()).format("YYYY-MM-DD"),
      datos: {},
      show: false,
      sexos: [
        { nombre: "Masculino", abbr: "M" },
        { nombre: "Femenino", abbr: "F" },
      ],
      TipoDocumentos: [],
      length: null,
      Perfil: [],
      Licencia: [],
      LicenciaTipo: [],
      Paises: [],
      dinamicValidation: [],
      Ubicacion1: [],
      Ubicacion2: [],
      Ubicacion3: [],
      Colegios_padres: [],
      menu3: false,
      previewImgLogo: "",
      imageSaveLogo: "",
      rutaServer: API_URL,
      rutaSpace: BUCKET_ORIGIN_SPACE,
      avatarCol: {
        url: null,
        state: false,
      },
      avatarWeb: {
        url: null,
        state: false,
      },
      previewImgAvatar: "",
      imageSaveAvatar: "",
      nacionalidades: [],
      valores: [
        { nombre: "NO", Value: 0 },
        { nombre: "SÍ", Value: 1 },
      ],
      dre: {},
      ugel: {},
      rul: {
        required: (value) => !!value || "Campo requerido",
        email: (value) =>
          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
          "El correo Electrónico es incorrecto",
        min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
        min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
        min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
        max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
        max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
        max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
        max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
        max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
        max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
        max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
        max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
        max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
        max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",
      },
    };
  },
  mounted() {
    this.loadMain();
  },
  computed: {

    validationRules() {
      return validationRules
    }

  },
  watch: {
    estadoComp() {
      if (this.estadoComp) {
        this.loadMain();
      } else {
        this.limpiarForm();
        this.limpiarFormUsuario();
      }
    },
  },
  methods: {

    datatest() {

      this.editedItem.id_usuario = 1,
        this.editedItem.id_colegio = 0,
        this.editedItem.web_colegio = "www.colegiogarcilaso",
        this.editedItem.correo_colegio = "incaigv@gmail.com",
        this.editedItem.direc_colegio = "Av Girasoles #223",
        this.editedItem.fec_constitucion = "1977-08-03",
        this.editedItem.fec_us_ing = "",
        this.editedItem.fec_us_mod = "",
        this.editedItem.extension = ".edu.pe",
        this.editedItem.logo_colegio = "",
        this.editedItem.nombre_colegio = "Inca Garcilaso de la Vega",
        this.editedItem.telf_colegio = "+013658044",
        this.editedItem.ruc_colegio = "20102545789",
        this.editedItem.es_sucursal = 0,
        this.editedItem.cambio_notas = true,
        this.editedItem.id = 0,
        this.editedItem.resolucion_colegio = "RES054985621",
        this.editedItem.responsable_nombre = "Juan Vilchez",
        this.editedItem.responsable_telf = "936585245",
        this.editedItem.responsable_correo = "juancav255@gmail.com",
        this.editedItem.parent_id_colegio = null,
        this.editedItem.estado_colegio = 1,
        this.editedItem.slogan_colegio = "33 Años educando con innovación",
        this.editedItem.ubicacion1 = "",
        this.editedItem.ubicacion2 = "",
        this.editedItem.ubicacion3 = "",
        this.editedItem.id_ubicacion1 = 15,
        this.editedItem.id_ubicacion2 = 128,
        this.editedItem.id_ubicacion3 = 1283,
        this.editedItem.id_dre = 33,
        this.editedItem.dre = "DRE Lima Metropolitana - DRELM",
        this.editedItem.id_ugel = 33,
        this.editedItem.ugel = "UGEL 06",
        this.editedItem.id_pais = 145

      this.datos.usu_usuario = "garcilaso",
        this.datos.password_usuario = "123456",
        this.datos.id_pais = 145,
        this.datos.nombre_persona = "Omar",
        this.datos.ape1_persona = "Cruzado",
        this.datos.ape2_persona = "Mirano",
        this.datos.id_tipo_documento = 1,
        this.datos.numdoc_persona = "46794613",
        this.datos.sexo_persona = "M",
        this.datos.fecnac_persona = "1976-02-11",
        this.datos.id_pais_nacimiento = 145,
        this.datos.id_nacionalidad = 145,
        this.datos.estado_usuario = 1,
        this.datos.id_ubicacion1 = 15,
        this.datos.id_ubicacion2 = 128,
        this.datos.id_ubicacion3 = 1283,
        this.datos.telf_persona = "965452011",
        this.datos.correo_persona = "omarco@gmail.com",
        this.datos.direc_persona = "Av Tulipanes, Etapa G #4442"

    },
    /** 
     _______________________
    |  MENSAJE DE SISTEMA */
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ...mapActions({ getDptoUbigeo1: "getDptoUbigeo1" }),
    /** 
     __________________________
    |  FUNCION CARGA INICIAL */
    async loadMain() {

      this.editedItem = this.parametros.items;
      if (this.parametros.evento == 'agregar') {
        this.$refs.formDatos.resetValidation();
        this.limpiarForm()

      } else {
        await this.getUsuarioWebMaster();
      }

      this.getAllSucursales();
    },

    changedinamicValidation(id) {
      switch (id) {
        case 1:
          this.dinamicValidation = validationRules.validateDni
          break;
        case 2:
          this.dinamicValidation = validationRules.validateDocument
          break;
        case 4:
          this.dinamicValidation = validationRules.validateRuc
          break;

        default:
          break;
      }
    },
    /** 
     _________________________________________________
    |  FUNCION OBTENER UBICACION1 DATOS DEL USUARIO */
    async getUbicacion1(idpais) {
      await this.getDptoUbigeo1(idpais)
      this.Ubicacion1 = this.$store.state.DptoUbigeo1;
      this.datos.id_pais = idpais;
    },
    /** 
     ____________________________________________________
    |  FUNCION OBTENER DATOS DEL WEBMASTER DEL COLEGIO */
    async getUsuarioWebMaster() {
      try {
        const response = await axios.get(`/manager/colegio/colegioUsuario/${this.parametros.items.id}`)

        if (response.data) {
          this.datos = response.data;

        } else {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `No existe usuario Webmaster para el colegio`,
            tiempo: null,
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        // this.$store.dispatch('getDptoUbigeo1', this.datos.id_pais_nacimiento);
        this.getDptoUbigeo1(this.datos.id_pais_nacimiento)
        await this.loadUbicacion2(this.datos.id_ubicacion1)
        await this.loadUbicacion3(this.datos.id_ubicacion2)
        await this.getNacionalidades(this.datos.id_pais_nacimiento);
        this.Ubicacion1 = this.$store.state.DptoUbigeo1;
        this.datos.id_usuario = this.datoLogin.id
      }
    },
    /** 
     __________________________________________________
    |  FUNCION CARGAR UBICACION PROVINCIA WEB MASTER */
    async loadUbicacion2(id) {
      try {
        let response = await axios.get("/mantenimiento/ubicacion2/" + id + "");
        this.Ubicacion2 = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    /** 
     _________________________________________________
    |  FUNCION CARGAR UBICACION DISTRITO WEB MASTER */
    async loadUbicacion3(id) {
      if (!id) return false;
      try {
        let response = await axios.get("/mantenimiento/ubicacion3/" + id + "");
        this.Ubicacion3 = response.data;
        //this.datos.id_ubicacion3 = null
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
     _________________________________________________
    |  FUNCION CARGAR UBICACION DISTRITO WEB MASTER */
    async getNacionalidades(idPais) {
      try {
        const response = await axios.get(`/mantenimiento/nacionalidades/pais/${idPais}`)
        this.nacionalidades = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    generateDataFake() {
      this.editedItem = {

      }
    },

    /** 
     ______________________________
    |  FUNCION GUARDAR REGISTROS */
    async saveItem() {

      if (this.$refs.formDatos.validate()) {
        this.loading = true;
        this.bloquearBotonGurdar = true;
        try {
          let response;
          this.datos.id_usuario = this.datoLogin.id
          this.datos.id_nacionalidad = this.datos.id_pais_nacimiento;
          if (this.parametros.evento == "agregar") {
            let params = { colegio: this.editedItem, usuario: this.datos };
            response = await axios.post("/manager/colegio", params);
            this.editedItem.id = response.data.id_colegio;
            this.datos.id_persona = response.data.id_personal;
          }

          if (this.parametros.evento == "editar") {

            let params = { colegio: this.editedItem, usuario: this.datos };
            response = await axios.put(
              `/manager/colegio/${this.editedItem.id}`,
              params
            );

          }

          if (response.data.success) {

            if (this.imageSaveLogo) {
              this.saveLogo();
            }

            if (this.imageSaveAvatar) {
              this.saveAvatar();
            }

            this.bloquearBotonGurdar = false;

            this.loading = false;

            this.setEnviarMens({
              tipo: response.data.messageT,
              mensaje: response.data.message,
              tiempo: 6000,
            });

            this.$emit("reloadMain");
            this.$emit("close");

          }
        } catch (error) {
          console.log(error);
          this.bloquearBotonGurdar = false;
        }
        this.$refs.formDatos.resetValidation();
      } else {
        this.bloquearBotonGurdar = false;
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe Ingresar todos los campos requeridos en el Formulario`,
          tiempo: null,
        });
      }
    },
    /** 
     ___________________________________
    |  FUNCION SUBIR LOGO DEL COLEGIO */
    async saveLogo() {

      let formData = new FormData();
      formData.append("subirArchivo", this.imageSaveLogo);
      formData.append("id_colegio", this.editedItem.id);
      formData.append("id_usuario", this.datoLogin.id);

      try {

        await axios.post("archivo/logoColegio", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
      } catch (error) {
        console.log(error);
      }
    },
    /** 
    _________________________________
   |  FUNCION SUBIR AVATAR USUARIO */
    async saveAvatar() {

      let formData = new FormData();
      formData.append("subirArchivo", this.imageSaveAvatar);
      formData.append("id_colegio", this.editedItem.id);
      formData.append("id_usuario", this.datoLogin.id);
      formData.append("id_persona", this.datos.id_persona);

      try {

        await axios.post("archivo/avatarPersona", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
      } catch (error) {
        console.log(error);
      }
    },
    /** 
     ______________________________
    |  FUNCION ACTIVAR CLIC LOGO */
    pickLogo() {
      this.$refs.imageCol.click();
    },
    /** 
     ________________________
    |  FUNCION CARGAR LOGO */
    onFileLogo(e) {
      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;
      // crea imagen temporar para visualizar
      this.createImageLogo(files[0]);

      if (files[0] !== undefined) {
        this.imageSaveLogo = files[0]; // this is an image file that can be sent to server...
      }

    },
    /** 
     _____________________________________________
    |  FUNCION CREAR IMAGEN LOGO - PREVIA VISTA */
    createImageLogo(file) {
      var image = new Image();
      console.log(image);
      var reader = new FileReader();
      reader.onload = (e) => {
        this.previewImgLogo = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    /** 
     ________________________________________
    |  FUNCION ACTIVAR CLIC AVATAR USUARIO */
    pickAvatar() {
      this.$refs.imageAvatar.click();
    },
    /** 
     __________________________________
    |  FUNCION CARGAR AVATAR USUARIO */
    onFileAvatar(e) {
      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;
      // crea imagen temporar para visualizar
      this.createImageAvatar(files[0]);

      if (files[0] !== undefined) {
        this.imageSaveAvatar = files[0]; // this is an image file that can be sent to server...
      }
    },
    /** 
     ________________________________________________
    |  FUNCION CREAR AVATAR USUARIO - PREVIA VISTA */
    createImageAvatar(file) {

      var reader = new FileReader();
      reader.onload = (e) => {
        this.previewImgAvatar = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    /** 
     _______________________________________
    |  FUNCION LIMPIAR FOMULARIO USUARIO  */
    async limpiarFormUsuario() {
      let dataForm = {
        id: 0,
        id_persona: 0,
        id_colegio: 0,
        id_tipo_documento: 0,
        master_ck1: 0,
        id_tipo_usuario: null,
        id_perfil: 0,
        numdoc_persona: "",
        ape1_persona: null,
        ape2_persona: null,
        nombre_persona: null,
        sexo_persona: "",
        fecnac_persona: "",
        telf_persona: "",
        correo_persona: "",
        direc_persona: "",
        avatar_persona: "",
        ruta_avatar_persona: null,
        estado_persona: 0,
        id_usuario: this.datoLogin.id,
        id_licencia: 0,
        id_licencia_tipo: 0,
        fecha_fin: null,
        usu_usuario: "",
        password_usuario: null,
        estado_usuario: 1,
        id_idioma: null,
        id_nacionalidad: 0,
        id_pais_nacimiento: 0,
        id_pais: 0,
        id_ubicacion1: 0,
        id_ubicacion2: 0,
        id_ubicacion3: 0,
      };
      this.avatarCol.state = false;
      this.avatarCol.url = null;
      this.avatarWeb.state = false;
      this.avatarWeb.url = null;
      this.datos = dataForm;
      this.previewImgAvatar = null;
      this.visualizarIdioma = false;
    },
    /** 
     _______________________________________
    |  FUNCION LIMPIAR FOMULARIO COLEGIO  */
    async limpiarForm() {
      this.editedItem = {
        id_usuario: this.datoLogin.id,
        id_colegio: this.datoLogin.id_colegio,
        web_colegio: "",
        correo_colegio: "",
        direc_colegio: "",
        fec_constitucion: "",
        fec_us_ing: "",
        fec_us_mod: "",
        extension: "",
        logo_colegio: "",
        nombre_colegio: "",
        telf_colegio: "",
        ruc_colegio: "",
        es_sucursal: 0,
        cambio_notas: true,
        id: 0,
        resolucion_colegio: "",
        responsable_nombre: "",
        responsable_telf: "",
        responsable_correo: "",
        parent_id_colegio: null,
        estado_colegio: 1,
        slogan_colegio: "",
        ubicacion1: "",
        ubicacion2: "",
        ubicacion3: "",
        id_ubicacion1: "",
        id_ubicacion2: "",
        id_ubicacion3: "",
        id_dre: "",
        dre: "",
        id_ugel: "",
        ugel: "",
      };

      // limpiar logo
      this.previewImgAvatar = "";
      this.imageSaveAvatar = "";

      this.previewImgLogo = "";
      this.imageSaveLogo = "";
    },
    /** 
     ___________________________________
    |  FUNCION PAIS POR NACIONALIDAD  */
    async select_pais() {
      this.get_Nacionalidades(this.datos.id_pais_nacimiento);
    },
    /** 
     ________________________________
    |  FUNCION OBTENER NACIONLIDAD  */
    async get_Nacionalidades(id = "") {
      let url = "/mantenimiento/nacionalidades";
      if (id != "" && id != undefined) {
        url = `${url}/pais/${id}/`;
      }
      await axios.get(url).then((response) => {
        this.nacionalidades = response.data;
      });
    },
    /** 
     ________________________________
    |  FUNCION LIMPIAR DRE Y UGEL  */
    clear_dre_ugel() {
      this.editedItem.id_dre = "";
      this.editedItem.dre = " ";
      this.editedItem.id_ugel = "";
      this.editedItem.ugel = " ";
    },
    /** 
     ______________________________________
    |  FUNCION OBTENER DRE POR PROVINCIA */
    async getDrebyProvince(id) {
      await axios.get(`/manager/dre/province/${id}`).then(({ data }) => {

        if (data) {
          this.dre = data;
          if (!data.id_distrito) {
            this.editedItem.dre = data.description;
            this.editedItem.id_dre = data.id;
          }
        }
      });
    },
    /** 
     ________________________________________
    |  FUNCION OBTENER UGEL POR PROVINCIA  */
    async getUgelbyProvince(id) {
      await axios.get(`/manager/ugel/province/${id}`).then(({ data }) => {
        if (data) {
          this.ugel = data;
          if (!data.id_distrito) {
            this.editedItem.id_ugel = data.id;
            this.editedItem.ugel = data.description;
          }
        }
      });
    },
    /** 
     _____________________________________________
    |  FUNCION LLAMAR UGEL Y DRE POR PROVINCIA  */
    async getUgelDreProvince(id) {
      await this.getDrebyProvince(id);
      await this.getUgelbyProvince(id);
    },
    /** 
     ______________________________________
    |  FUNCION OBTENER DRE POR DISTRITO */
    async getDrebyDistrict(id) {
      await axios.get(`/manager/dre/district/${id}`).then(({ data }) => {

        if (data) {
          if (data.id_distrito && this.dre.id_distrito) {
            this.editedItem.dre = data.description;
            this.editedItem.id_dre = data.id;
          }
        }
      });
    },
    /** 
     _______________________________________
    |  FUNCION OBTENER UGEL POR DISTRITO  */
    async getUgelbyDistrict(id) {
      await axios.get(`/manager/ugel/district/${id}`).then(({ data }) => {
        if (data) {
          if (data.id_distrito && this.ugel.id_distrito) {
            this.editedItem.id_ugel = data.id;
            this.editedItem.ugel = data.description;
          }
        }
      });
    },
    /** 
     ____________________________________________
    |  FUNCION LLAMAR UGEL Y DRE POR DISTRITO  */
    async getUgelDreDistrito(id) {
      await this.getDrebyDistrict(id);
      await this.getUgelbyDistrict(id); //
    },
    /** 
     __________________________________________
    |  FUNCION INVOCAR O LLAMAR UGEL METODOS */
    async district(id) {

      if (this.dre.id_distrito && this.ugel.id_distrito) {
        await this.getUgelDreDistrito(id);
      }
    },
    /** 
     __________________________
    |  FUNCION CERRAR MODAL  */
    cerrarModal() {
      this.$emit('close')
      this.$refs.formDatos.resetValidation();
    },

    async getAllSucursales() {
      try {
        let response = await axios.get("/manager/colegio/colegiosPadres");
        this.Colegios_padres = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
  },
};
</script>

<style scoped>
.fondo_add_img {
  cursor: pointer;
  cursor: hand;
  max-width: 100%;
  /* Esto asegura que la imagen no sea más ancha que su contenedor */
  max-height: 100%;
  /* Esto asegura que la imagen no sea más alta que su contenedor */
  height: auto;
  /* Esto mantiene la proporción original de la imagen */

}

.avatar_fondo_add_img {
  border-radius: 10%;
  border: solid 1px rgb(197, 197, 197);
  border-style: dashed;
}
</style>
